enum OrderStatusEnum {
  PREPARING = 'Preparing',
  READY = 'Ready',
  COLLECTED = 'Collected',
  MISSED_COLLECTION = 'Missed Colletion',
  CANCELLED = 'Cancelled',
}

export default OrderStatusEnum
